import React, { createContext, useState, useContext, useEffect } from 'react';

const NotificationContext = createContext();

export const useNotification = () => {
  return useContext(NotificationContext);
};

export const NotificationProvider = ({ children }) => {
  const [notifications, setNotifications] = useState([]);
  const [isOpen, setIsOpen] = useState(false);
  const [isProcessing, setIsProcessing] = useState(false); // For transaction processing
  const [transactionId, setTransactionId] = useState(null); // For tracking current transaction

  useEffect(() => {
    // Adding static data to test notifications
    const staticNotifications = [
      {
        id: 1,
        type: 'Success',
        message: 'Your transaction was completed successfully.',
        transactionUrl: 'https://example.com/transaction/1',
        seen: false,
      },
      {
        id: 2,
        type: 'Error',
        message: 'There was an issue with your payment.',
        transactionUrl: 'https://example.com/transaction/2',
        seen: false,
      },
    ];

    setNotifications(staticNotifications);
  }, []);

  // Function to start the transaction and show processing loader
  const startTransaction = () => {
    setIsProcessing(true);
    setTransactionId(Date.now()); // Unique ID for this transaction

    // Simulate transaction processing (e.g., via an API call)
    setTimeout(() => {
      setIsProcessing(false);
      addTransactionNotification(); // Add notification when the transaction is complete
    }, 5000); // Simulating a 5-second transaction processing time
  };

  // Function to add a transaction completion notification
  const addTransactionNotification = () => {
    const newNotification = {
      id: Date.now(),
      type: 'Transaction Complete',
      message: 'Your transaction has been completed successfully.',
      transactionUrl: `https://example.com/transaction/${transactionId}`,
      seen: false,
    };

    setNotifications((prevNotifications) => [...prevNotifications, newNotification]);
  };

  const toggleNotificationPanel = () => {
    setIsOpen((prev) => !prev);
  };

  const markAsSeen = (id) => {
    setNotifications((prev) =>
      prev.map((notif) =>
        notif.id === id ? { ...notif, seen: true } : notif
      )
    );
  };

  const unseenNotifications = notifications.filter((notif) => !notif.seen);
  const seenNotifications = notifications.filter((notif) => notif.seen);

  return (
    <NotificationContext.Provider
      value={{
        notifications,
        toggleNotificationPanel,
        markAsSeen,
        unseenNotifications,
        seenNotifications,
        isOpen,
        startTransaction,
        isProcessing,
      }}
    >
      {children}
    </NotificationContext.Provider>
  );
};
